<template>
  <div class="index-box">
    <div v-for="(profiles, index) in profiles" :key="index">
      <video
        class="videoBox"
        :ref="`video${index}`"
        controls
        :poster="profiles.pic"
      >
        <source :src="profiles.videoUrl" type="video/mp4" />
      </video>
      <audio
        class="audioBox"
        :src="profiles.songUrl"
        controls="controls"
        align="center"
      ></audio>
      <!-- <div class="listTitleBox">
        <div class="identification"></div>
        <div class="listTitle">学校介绍</div>
      </div> -->
      <div class="text-jieshao" v-if="contentList != ''">
        <div class="contentTxt">
          <div v-for="(segment, index) in contentList" :key="index">
            <div v-html="segment"></div>  
          </div>
        </div>
      </div>
      <!-- <div class="listTitleBox">
        <div class="identification"></div>
        <div class="listTitle">校史沿革</div>
      </div>
      <div class="text-jieshao">
        <div class="contentTxt">
          <div v-for="(segment, index) in lishiList" :key="index">
            {{ segment }}
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import btnGeci from "@/assets/image/almaMater/btn_geci_nor@2x.png";

export default {
  data() {
    return {
      video:
        "https://glxy.sie.edu.cn/__local/C/A9/BD/3FEAD36CC04E95ECD9DE769DB78_C9DF43DE_EBE7891.mp4?e=.mp4",
      schoolSong:
        "https://sie.edu.cn/__local/7/F8/D7/9E7C23F38087A0C1B259425E8D3_745F9A8D_21F11B.mp3",
      btnGeci,
      profiles: [],
      lishi: "",
      contentList: [],
    };
  },
  created() {
    this.getProfiles();
  },
  methods: {
    async getProfiles() {
      const result = await this.$http.get("/schoolProfiles/getProfiles");
      this.profiles.push(result.data);
      // 学校历史--使用split方法根据关键字分割字符串
      const content = result.data.content.split("\n");
      // 重新组合分段，包含关键字
      const contentList = [];
      for (let i = 0; i < content.length; i++) {
        contentList.push(content[i]);
      }
      this.contentList = contentList;
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  // position: p;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .videoBox {
    display: flex;
    width: 95vw;
    object-fit: cover;
    height: 20vh;
    border-radius: 10px;
    // margin-left: 15.5vw;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid #e2e2e2;
  }
  .audioBox {
    display: flex;
    width: 95vw;
    // height: 20vh;
    border-radius: 10px;
    // margin-left: 2.5vw;
    margin-top: 10px;
    border: 1px solid #e2e2e2;
  }
  .geci {
    position: relative;
    display: flex;
    width: 95vw;
  }

  .listTitleBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 95vw;
    margin-left: 2.5vw;
    margin-top: 20px;
    .identification {
      width: 5px;
      height: 18px;
      background: #00706e;
      margin-right: 5px;
    }
    .listTitle {
      font-size: 1.2rem;
      color: #000;
      font-weight: 600;
      width: 80vw;
    }
  }

  .text-jieshao {
    display: flex;
    flex-direction: column;
    width: 95vw;
    border-radius: 10px;
    border: 1px solid #e2e2e2;
    background: #fff;
    font-size: 1rem;
    font-weight: 500;
    line-height: 25px;//行间距
    color: #747474;
    text-indent: 4ch;//首行缩进
    text-align: justify;//两端对齐
    margin-top: 10px;
    .contentTxt {
      padding: 0.5rem 1rem 1rem 1rem;
      line-height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/SchoolHistory.vue